export const environment = {
  production: true,
  enableSetRCsubaccount: false,
  enableDashboard: false,
  firstIndexPnl: true,
  sURL: 'https://uat-api.sadmincontrol.com/v1/api/',
  bURL: 'https://uat-api.sadmincontrol.com',
  mURL: 'https://uat-market.sadmincontrol.com',
  riskCalculatorURL: 'https://uat-feed-rust.sadmincontrol.com/risk_calculator',
  betTickerURL:'https://uat-betticker',
  betTickerV1URL:'https://uat-betticker-v1',
  kjsport9URL:'https://kjs-back.pkrsrv.com/webadmin-VDX0Xj'
};
